/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import menuItem from "examples/Items/NotificationItem/styles";
import MDTypography from "components/MDTypography";
import MenuItem from "@mui/material/MenuItem";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import _ from "lodash";
import SlideText from "./textAnimation";
import { Badge } from "@mui/material";

export default function Notificaciones({ VerNotificacion }) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { NotificacionesSeparadas } = useSelector((state) => state.solicitud);
  var solicitudes = [];
  var expedientes = [];
  //obtener los expedientes unicos por ID
  var expedientesUnicos = _.uniqBy(NotificacionesSeparadas?.expedientes, "idSolicitud");
  _.map(expedientesUnicos, (item) => {
    //obneter las notificaciones de cada solicitud
    const notificacionesXexpe = _.filter(NotificacionesSeparadas?.expedientes, {
      idSolicitud: item.idSolicitud,
    });
    //ordenar por la ultima notificacion
    const notificacionesXexpeOrdenadas = _.orderBy(
      notificacionesXexpe,
      ["idNotificacion"],
      ["desc"]
    );
    expedientes.push({
      vista: "expediente",
      idSolicitud: item.idSolicitud,
      candidato: item.candidato,
      notificaciones: _.map(notificacionesXexpeOrdenadas, "mensaje"),
    });
  });

  //obtener los expedientes unicos por ID
  var solicitudesUnicos = _.uniqBy(NotificacionesSeparadas?.solicitudes, "idSolicitud");
  _.map(solicitudesUnicos, (item) => {
    //obneter las notificaciones de cada solicitud
    const notificacionesSoli = _.filter(NotificacionesSeparadas?.solicitudes, {
      idSolicitud: item.idSolicitud,
    });
    //ordenar por la ultima notificacion
    const notificacionesSoliOrdenadas = _.orderBy(notificacionesSoli, ["idNotificacion"], ["desc"]);
    solicitudes.push({
      vista: "solicitud",
      idSolicitud: item.idSolicitud,
      candidato: item.candidato,
      notificaciones: _.map(notificacionesSoliOrdenadas, "mensaje"),
    });
  });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Solicitudes" {...a11yProps(0)} sx={{ fontSize: 14 }} />
            <Tab label="Expedientes" {...a11yProps(1)} sx={{ fontSize: 14 }} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          {_.map(solicitudes, (item) => {
            return (
              <MenuItem
                sx={(theme) => menuItem(theme)}
                onClick={() => VerNotificacion(item.idSolicitud, item.vista)}
              >
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <Badge
                    badgeContent={item?.notificaciones?.length || 0}
                    color="secondary"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MDAvatar alt="profile-image" size="sm" shadow="sm" bgColor="info">
                      {`${item.candidato?.split(" ")[0][0]}${item.candidato?.split(" ")[1][0]}`}
                    </MDAvatar>
                  </Badge>
                  <MDBox ml={2} lineHeight={1}>
                    <MDTypography display="block" variant="button" fontWeight="medium">
                      {item.candidato}
                    </MDTypography>
                    <SlideText textos={item.notificaciones} />
                  </MDBox>
                </MDBox>
              </MenuItem>
            );
          })}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {_.map(expedientes, (item) => {
            return (
              <MenuItem
                sx={(theme) => menuItem(theme)}
                onClick={() => VerNotificacion(item.idSolicitud, item.vista)}
              >
                <MDBox display="flex" alignItems="center" lineHeight={1}>
                  <Badge
                    badgeContent={item?.notificaciones?.length || 0}
                    color="secondary"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MDAvatar alt="profile-image" size="sm" shadow="sm" bgColor="info">
                      {`${item.candidato?.split(" ")[0][0]}${item.candidato?.split(" ")[1][0]}`}
                    </MDAvatar>
                  </Badge>

                  <MDBox ml={2} lineHeight={1}>
                    <MDTypography display="block" variant="button" fontWeight="medium">
                      {item.candidato}
                    </MDTypography>
                    <SlideText textos={item.notificaciones} />
                  </MDBox>
                </MDBox>
              </MenuItem>
            );
          })}
        </CustomTabPanel>
      </Box>
    </>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
